"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyValidator = exports.RegexBasedValidator = exports.EmailValidator = exports.RequiredValidator = exports.Validator = void 0;

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _validator2 = _interopRequireDefault(require("validator"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Validator = /*#__PURE__*/function () {
  function Validator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        customMessage = _ref.customMessage,
        allowBlank = _ref.allowBlank;

    (0, _classCallCheck2["default"])(this, Validator);
    this.customMessage = void 0;
    this.allowBlank = void 0;
    this.customMessage = customMessage;
    this.allowBlank = !!allowBlank;
  }

  (0, _createClass2["default"])(Validator, [{
    key: "getRequirements",
    value: function getRequirements() {
      return [];
    }
  }, {
    key: "validateText",
    value: function () {
      var _validateText = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(text) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", null);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function validateText(_x) {
        return _validateText.apply(this, arguments);
      }

      return validateText;
    }()
  }, {
    key: "validate",
    value: function () {
      var _validate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(text) {
        var _iterator, _step, _validator, response;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.allowBlank || text)) {
                  _context2.next = 22;
                  break;
                }

                _iterator = _createForOfIteratorHelper(this.getRequirements());
                _context2.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 13;
                  break;
                }

                _validator = _step.value;
                _context2.next = 8;
                return _validator.validate(text);

              case 8:
                response = _context2.sent;

                if (!(response != null)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", response);

              case 11:
                _context2.next = 4;
                break;

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);

                _iterator.e(_context2.t0);

              case 18:
                _context2.prev = 18;

                _iterator.f();

                return _context2.finish(18);

              case 21:
                return _context2.abrupt("return", this.validateText((text || "").trim()));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 15, 18, 21]]);
      }));

      function validate(_x2) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }]);
  return Validator;
}();

exports.Validator = Validator;

var RequiredValidator = /*#__PURE__*/function (_Validator) {
  (0, _inherits2["default"])(RequiredValidator, _Validator);

  var _super = _createSuper(RequiredValidator);

  function RequiredValidator() {
    (0, _classCallCheck2["default"])(this, RequiredValidator);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RequiredValidator, [{
    key: "validateText",
    value: function () {
      var _validateText2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(text) {
        var value, customMessage;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                value = text.trim();
                customMessage = this.customMessage;

                if (!(value.trim().length === 0)) {
                  _context3.next = 6;
                  break;
                }

                if (!customMessage) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", customMessage);

              case 5:
                return _context3.abrupt("return", "This field is required");

              case 6:
                return _context3.abrupt("return", null);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validateText(_x3) {
        return _validateText2.apply(this, arguments);
      }

      return validateText;
    }()
  }]);
  return RequiredValidator;
}(Validator);

exports.RequiredValidator = RequiredValidator;

var EmailValidator = /*#__PURE__*/function (_Validator2) {
  (0, _inherits2["default"])(EmailValidator, _Validator2);

  var _super2 = _createSuper(EmailValidator);

  function EmailValidator() {
    (0, _classCallCheck2["default"])(this, EmailValidator);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(EmailValidator, [{
    key: "validateText",
    value: function () {
      var _validateText3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(text) {
        var customMessage, value;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                customMessage = this.customMessage;
                value = text.trim();

                if (_validator2["default"].isEmail(value)) {
                  _context4.next = 6;
                  break;
                }

                if (!customMessage) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", customMessage);

              case 5:
                return _context4.abrupt("return", "Please enter a valid email");

              case 6:
                return _context4.abrupt("return", null);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateText(_x4) {
        return _validateText3.apply(this, arguments);
      }

      return validateText;
    }()
  }]);
  return EmailValidator;
}(Validator);

exports.EmailValidator = EmailValidator;

var RegexBasedValidator = /*#__PURE__*/function (_Validator3) {
  (0, _inherits2["default"])(RegexBasedValidator, _Validator3);

  var _super3 = _createSuper(RegexBasedValidator);

  function RegexBasedValidator() {
    var _this;

    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        customMessage = _ref2.customMessage,
        pattern = _ref2.pattern;

    (0, _classCallCheck2["default"])(this, RegexBasedValidator);
    _this = _super3.call(this, {
      customMessage: customMessage
    });
    _this.pattern = void 0;
    _this.pattern = pattern;
    return _this;
  }

  (0, _createClass2["default"])(RegexBasedValidator, [{
    key: "validateText",
    value: function () {
      var _validateText4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(text) {
        var customMessage, pattern;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                customMessage = this.customMessage, pattern = this.pattern;

                if (!(text.length == 0)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", null);

              case 3:
                if (pattern.test(text)) {
                  _context5.next = 7;
                  break;
                }

                if (!customMessage) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", customMessage);

              case 6:
                return _context5.abrupt("return", "Provided value is not valid");

              case 7:
                return _context5.abrupt("return", null);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function validateText(_x5) {
        return _validateText4.apply(this, arguments);
      }

      return validateText;
    }()
  }]);
  return RegexBasedValidator;
}(Validator);

exports.RegexBasedValidator = RegexBasedValidator;

var CurrencyValidator = /*#__PURE__*/function (_Validator4) {
  (0, _inherits2["default"])(CurrencyValidator, _Validator4);

  var _super4 = _createSuper(CurrencyValidator);

  function CurrencyValidator() {
    var _this2;

    (0, _classCallCheck2["default"])(this, CurrencyValidator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super4.call.apply(_super4, [this].concat(args));
    _this2.PATTERN = /^-?\$?[0-9]+(\.[0-9]{1,2})?$|^\$?[\.]([\d][\d]?)$/;
    return _this2;
  }

  (0, _createClass2["default"])(CurrencyValidator, [{
    key: "getRequirements",
    value: function getRequirements() {
      var customMessage = this.customMessage,
          PATTERN = this.PATTERN;
      return [new RegexBasedValidator({
        customMessage: customMessage || "Invalid currency format",
        pattern: PATTERN
      })];
    }
  }]);
  return CurrencyValidator;
}(Validator);

exports.CurrencyValidator = CurrencyValidator;